module.exports = __webpack_public_path__ + "bh.9cd46cfe83826d970377.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/bh.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/bh.svg
// module chunks = styles